import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';

const CartDrawer = dynamic(() => import('../organs/cart'));
const Vestibule = dynamic(() => import('../organs/vestibule'));

const DefaultLayout = (props) => {
  const navigation = useSelector((state) => state.navigation);
  const promotions = useSelector((state) => state.promotions.content);

  return (
    <div id="main">
      <Vestibule
        navigation={navigation.desktop || {}}
        mobileNavigation={navigation.mobile || []}
        promotionContent={promotions || []}
      />

      <CartDrawer />

      {props.children}
    </div>
  );
};

DefaultLayout.whyDidYouRender = true;

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default DefaultLayout;
